import { attendanceApi } from '../../../services/api';
import type { CurrentUser, DailyAttendanceRecord, AttendanceStats } from '../models';

/**
 * 출결 데이터 접근 계층
 * API 호출을 담당하고 도메인 모델로 변환
 */
export class AttendanceRepository {
  /**
   * 현재 이용 중인 사용자 목록 조회
   */
  async getCurrentUsers(): Promise<CurrentUser[]> {
    try {
      const users = await attendanceApi.getCurrentUsers();
      return users;
    } catch (error) {
      console.error('현재 이용자 조회 실패:', error);
      throw error;
    }
  }

  /**
   * 특정 날짜의 일일 출결 기록 조회
   */
  async getDailyAttendance(studyroomId: number, date: string): Promise<DailyAttendanceRecord[]> {
    try {
      const records = await attendanceApi.getDailyAttendance(studyroomId, date);
      return records;
    } catch (error) {
      console.error('일일 출결 기록 조회 실패:', error);
      throw error;
    }
  }

  /**
   * 출결 통계 조회
   */
  async getStats(): Promise<AttendanceStats> {
    try {
      const stats = await attendanceApi.getStats();
      return stats;
    } catch (error) {
      console.error('출결 통계 조회 실패:', error);
      throw error;
    }
  }
}

// 싱글톤 인스턴스
export const attendanceRepository = new AttendanceRepository();
